import Actions from '../../odata/actions';

const actions = new Actions('explanation', 'explanations');

export default actions;
